import { FatGreenOutlineButton, FatRedOutlineButton } from 'common';
import { Pane } from 'evergreen-ui';
import { Offer, OfferStatus, useCancelOffer$ } from 'offer';
import { useGoToReferralListPage } from 'providerapp/core/routes';
import React, { useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { ConfirmOfferCancelDialog, useConfirmOfferCancelDialog } from './ConfirmOfferCancelDialog';
import {OfferConversationPopup} from './conversation';
import { OfferDetails } from './OfferDetails';
import { OfferFormHeader } from './OfferFormHeader';
import { SubmissionInfo } from './SubmissionInfo';
import { useApplicationRootUrl } from 'common/component/ApplicationRootContext';
import { showToast } from 'common';
import { FeatureFlagSwitch, ProviderPortalFeatureFlag } from 'featureflag';

type OfferViewProps = {
    offer: Offer;
}
export const OfferView = ({offer}: OfferViewProps) => {
    const {referral, guid: offerGuid} = offer;
    const {
        execute,
    } = useCancelOffer$(offerGuid);

    const history = useHistory();
    const rootUrl = useApplicationRootUrl();
    const {url} = useRouteMatch();
    const cancelOffer = useCallback(async () => {
        const {data} = await execute();
        if (data?.cancelOffer) {
            showToast.success(`Offer for Referral ${referral.caseNumber} is cancelled`);
            history.push(`${rootUrl}/referral`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [execute, referral]);

    const goToReferralListPage = useGoToReferralListPage();
    const show$ = useConfirmOfferCancelDialog();

    return (
        <Pane className='max-h-full h-full box-border portal-provider-offer-form-container flex flex-col overflow-y-scroll'>
            <OfferFormHeader caseNumber={referral.caseNumber} onClose={goToReferralListPage}  conversationExt={
                <FeatureFlagSwitch flag={ProviderPortalFeatureFlag.BHPNPP_3077_IS_TWO_WAY_MESSAGING_DISABLED} negate>
                    <div className='pl-2'>
                        <OfferConversationPopup
                            offerGuid={offerGuid}
                            conversationSummary={offer.conversationSummary}
                            readOnly={offer.status === OfferStatus.ACCEPTED}
                        />
                    </div>
                </FeatureFlagSwitch>
            }/>
            <SubmissionInfo offer={offer}/>

            <OfferDetails referral={ referral } offer={ offer } />

            <Pane className='portal-provider-offer-form-actions portal-provider-bg flex justify-evenly'>
                <Pane width={200}>
                    {offer.status === OfferStatus.SUBMITTED &&
                    <FatGreenOutlineButton text='Modify' onClick={() => history.push(`${url}/edit`)}/>
                    }
                </Pane>
                <Pane width={200}>
                    {offer.status === OfferStatus.SUBMITTED &&
                    <FatRedOutlineButton text='Cancel Offer' onClick={() => show$.next(true)}/>
                    }
                </Pane>
            </Pane>

            <ConfirmOfferCancelDialog show$={show$} onConfirmed={cancelOffer} />
        </Pane>
    );
}
